import { userHasPermission } from '@/components/security/AppRoles';
import { INTEGRATION_IT_ROLES } from '../config';
import { useUserInfo } from '@/hooks';

const useIsIntegrationIt = (): boolean => {
  const { permissions } = useUserInfo();
  return userHasPermission(permissions, INTEGRATION_IT_ROLES);
};

export default useIsIntegrationIt;
